export enum TicketDeliveryMethod {
  swift = 'swift',
  mTicket = 'm-ticket',
}
